import { render, staticRenderFns } from "./AddSecondFactors.vue?vue&type=template&id=3017bf2c"
import script from "./AddSecondFactors.vue?vue&type=script&lang=js"
export * from "./AddSecondFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports